// extracted by mini-css-extract-plugin
module.exports = {"toggleWrapper":"style__toggleWrapper__smoyO"};